export default __webpack_public_path__ + "98a44d319f05cc1c8a973efda9ef47c4.png";